import React, { Component } from "react"
import PropTypes from "prop-types"
import { API } from "aws-amplify"

import { createBillingPortalSession }  from "../../graphql/mutations"


export class StripePortal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: "ready",
      error: null
    }
    this.redirectToStripePortal = this.redirectToStripePortal.bind(this)
  }

  async redirectToStripePortal() {
    this.setState({status: "loading"})
    try {
      let response = await API.graphql(
        {
          query: createBillingPortalSession,
          variables: {
            returnUrl: this.props.returnUrl
          }
        }
      )
      window.location.href = response.data.createBillingPortalSession.url
    } catch (error) {
      console.log("Error: ", error)
      this.setState({error: error})
    }
  }

  render() {
    return (
      <>
        {this.state.status === "loading" ?
          <span className="button button--minor">Loading...</span>
          :
          <button className="button button--minor" onClick={this.redirectToStripePortal}>
            {this.props.caption}
          </button>
        }
        {this.state.error ? <p className="error">{this.state.error}</p> : ""}
      </>
    )
  }
}

StripePortal.propTypes = {
  returnUrl: PropTypes.string,
  caption: PropTypes.string,
}

StripePortal.defaultPropTypes = {
  returnUrl: "",
  caption: "Manage Subscriptions"
}

export default StripePortal
